import type { CatalogRatioShortData } from '@gql/graphql';
import { FieldGroup } from 'uikit';

import { Text } from '@consta/uikit/Text';
import * as R from 'ramda';
import type { Control } from 'react-hook-form';

import { ControlledExternalFormMultiselect } from './components/ControlledExternalFormMultiselect';

import Styles from './ratiosFormField.module.css';

type TRatiosFormFieldProps = {
    control: Control;
    onOpenAddCoefficientModal?: () => void;
    items: CatalogRatioShortData[];
    disabled?: boolean;
};

export const RatiosFormField = (props: TRatiosFormFieldProps) => {
    const { control, onOpenAddCoefficientModal, items, disabled } = props;

    const adaptedItems = R.pipe(
        R.filter(Boolean),
        R.map((item: CatalogRatioShortData) => ({ ...item, label: item.code })),
        R.sortBy(R.prop('label')),
    )(items);

    return (
        <div className="Select Select_labelPosition_left Select_size_s Select_view_default Select_type_select">
            <div className="Text Text_lineHeight_m Text_size_s Text_view_secondary FieldLabel Select-Label Select-Label_labelPosition_left">
                Коэффициенты к расценке
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <FieldGroup size="s" className={Styles.ratiosField}>
                    <ControlledExternalFormMultiselect
                        name="ratios"
                        control={control}
                        classNameContainer={Styles.ratiosMultiselect}
                        disabled={disabled}
                        onSearchFormOpen={onOpenAddCoefficientModal}
                    />
                    <div />
                </FieldGroup>
                {!!adaptedItems.length && (
                    <Text size="s" view="secondary">
                        Выбрано коэффициентов: {adaptedItems.length}
                    </Text>
                )}
            </div>
        </div>
    );
};

RatiosFormField.displayName = 'RatiosFormField';
